export default function FinanceSkeleton() {
  return (
    <div className="bg-background-50 rounded-xl px-4 py-3.5 border border-background-200/60 animate-pulse">
      <div className="flex items-center gap-2 mb-2">
        <div className="h-3 w-16 bg-background-200 rounded" />
        <div className="h-3 w-3 bg-background-200 rounded-full" />
        <div className="h-3 w-12 bg-background-200 rounded" />
      </div>
      <div className="h-4 w-full bg-background-200 rounded mb-1" />
      <div className="h-3 w-3/4 bg-background-200 rounded mb-2.5" />
      <div className="flex items-center gap-1.5">
        <div className="h-4 w-12 bg-background-200 rounded-full" />
        <div className="h-4 w-10 bg-background-200 rounded-full" />
      </div>
    </div>
  );
}